/**
 * <ry-field>
 *
 * Form field wrapper with label.
 *
 * Usage:
 * <ry-field label="Email">
 *   <input type="email" placeholder="you@example.com">
 * </ry-field>
 *
 * JS uses data-ry-target for queries, CSS uses classes for styling.
 */

import { RyElement } from '../core/ry-element.js';

export class RyField extends RyElement {
  setup(): void {
    this.#transformMarkup();
  }

  #transformMarkup(): void {
    // If already has label, skip
    if (this.$('[data-ry-target="label"]')) return;

    const labelText = this.getAttribute('label');
    if (!labelText) return;

    const input = this.$<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>('input, textarea, select');
    if (!input) return;

    // Generate ID if needed
    const inputId = input.id || `ry-field-${Math.random().toString(36).slice(2, 9)}`;
    input.id = inputId;

    // data-ry-target for JS queries, class for CSS styling
    const label = document.createElement('label');
    label.setAttribute('data-ry-target', 'label');
    label.className = 'ry-label';
    label.setAttribute('for', inputId);
    label.textContent = labelText;

    this.insertBefore(label, input);
  }
}

customElements.define('ry-field', RyField);
